// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useEffect } from "../00-boot.jsx";
// ═══ V3-T1 · effets MICRO-AUTONOMES ═════════════════════════════════════════
//  Prouvés sans aucune dépendance à App() par tools/effect-ownership.mjs
//  (verdict « MIGRABLE:utilitaire » : imports + `me` + globals navigateur, rien
//  d'autre). Corps déplacés OCTET POUR OCTET ; App() appelle chaque hook À LA
//  PLACE EXACTE de l'ancien effet → l'ordre d'exécution des effets est inchangé.

// ── Lot Qualité (a11y, 2026-07-04) : association automatique label ↔ champ ──────────────────────
// Les 65 <label> historiques n'ont aucun htmlFor → les lecteurs d'écran n'annoncent pas le nom des
// champs, et taper le libellé ne focalise rien. Ce mécanisme apparie chaque label sans `for` au
// premier champ qui le suit (frère direct ou descendant des 3 frères suivants), en générant un id
// stable. React ne gère pas ces attributs (jamais rendus) → il ne les retire pas ; les nœuds
// recréés (changement d'écran) sont ré-appariés par le MutationObserver (débounce 150 ms).
// Labels purement décoratifs (suivis de boutons, pas de champ) : ignorés. Zéro impact visuel.
function useA11yLabelPairing(){
  useEffect(()=>{
    let seq=0,t=null;
    const pair=()=>{
      document.querySelectorAll("label:not([for])").forEach(lb=>{
        if(lb.querySelector("input,select,textarea")) return; // association implicite déjà correcte
        let el=lb.nextElementSibling,ctl=null;
        for(let i=0;i<3&&el&&!ctl;i++,el=el.nextElementSibling){
          ctl=(el.matches&&el.matches("input,select,textarea"))?el:(el.querySelector?el.querySelector("input,select,textarea"):null);
        }
        if(!ctl||ctl.closest("label")) return;
        if(!ctl.id) ctl.id="lnc-f"+(++seq)+"-"+Math.random().toString(36).slice(2,7);
        lb.setAttribute("for",ctl.id);
      });
    };
    pair();
    const mo=new MutationObserver(()=>{clearTimeout(t);t=setTimeout(pair,150);});
    mo.observe(document.body,{childList:true,subtree:true});
    return ()=>{clearTimeout(t);mo.disconnect();};
  },[]);
}
export { useA11yLabelPairing };
